import { Box, TextV2 } from '@withjoy/joykit';
import { styled, pxToRem } from '@withjoy/joykit/theme';
import { animationTransition } from '@shared/utils/animationTransition';
import { ParticleJoyLogo } from '@shared/components/ParticleJoyLogo';

export const ADMIN_HEADER_HEIGHT_MOBILE = 64;
export const ADMIN_HEADER_HEIGHT_DESKTOP = 80;
export const MOBILE_NAV_ROW_HEIGHT = 48;

/**
 * Shared header height constant used by both Root and Spacer components.
 * Ensures spacer height stays in sync with header height.
 */
export const HEADER_HEIGHT = {
  base: pxToRem(ADMIN_HEADER_HEIGHT_MOBILE),
  md: pxToRem(ADMIN_HEADER_HEIGHT_DESKTOP),
} as const;

export const HEADER_HEIGHT_FIXED = pxToRem(80);

export const StyledRoot = styled(Box)`
  @media print {
    display: none;
  }
`;

export const StyledLeftSection = styled(Box)``;

export const StyledRightSection = styled(Box)``;

export const StyledTitle = styled(TextV2)``;

/**
 * Container for the combined menu trigger zone (hamburger + Joy logo).
 * Hover anywhere in this zone triggers both the hamburger hover effect and particle animation.
 */
export const StyledMenuTriggerZone = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.space[4]};
  cursor: pointer;
`;

/**
 * Wrapper for the hamburger icon with hover/active states.
 * The hover effect (gray background) only appears around the hamburger,
 * but is triggered when hovering anywhere in the parent StyledMenuTriggerZone.
 */
export const StyledHamburgerWrapper = styled.div<{ $isHovered: boolean; $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space[1]};
  border-radius: ${({ theme }) => theme.radii[2]};
  color: inherit;
  background-color: ${({ $isHovered, $isActive, theme }) => ($isActive ? theme.colors.mono3 : $isHovered ? theme.colors.mono2 : 'transparent')};
  ${({ $isHovered, theme }) => $isHovered && `color: ${theme.colors.newUIBrandPrimary};`}
  transition: ${animationTransition('background-color', 'color')};
`;

/**
 * Styled ParticleJoyLogo for the admin header.
 * Hidden on mobile to reclaim horizontal space for the title;
 * the hamburger menu already contains Joy branding.
 */
export const StyledParticleJoyLogo = styled(ParticleJoyLogo)`
  display: none;

  ${({ theme }) => theme.mediaQueries.md} {
    display: block;
  }

  transform: translateY(${pxToRem(4)});

  & > div > svg {
    width: ${pxToRem(50.824)};
    height: ${pxToRem(32)};
  }

  & canvas {
    width: ${pxToRem(50.824)} !important;
  }
`;
